import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { saveAuthData } from '../Auth/Signin/Signin';

export default function useAuthCache() {
  const { 
    isAuthenticated, user, isLoading, 
    getAccessTokenSilently 
  } = useAuth0();

  useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      (async () => {
        try {
          const token = await getAccessTokenSilently();
          saveAuthData(token, user);
        } catch {
          // Token indisponível (ex.: usuário bloqueado após sessão residual)
        }
      })();
    }
  }, [isAuthenticated, user, isLoading, getAccessTokenSilently]);

  // Também grava o user assim que o Auth0 o disponibiliza (sem esperar o token),
  // para o menu reagir via re-render do Auth0 imediatamente após o popup.
  useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      saveAuthData(null, user);
    }
  }, [isAuthenticated, user, isLoading]);

  return {
    isAuthenticated,
    user,
    isLoading
  };
}

